import { onlineManager } from "@tanstack/react-query";

export const TILE_POLLING_INTERVAL_MS = 10000;
export const TILE_POLLING_JITTER_MS = 5000;

function stableJitterMs(value?: string): number {
  if (!value) {
    return 0;
  }

  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % TILE_POLLING_JITTER_MS;
  }
  return hash;
}

/** Poll for new tiles only while online and the field has none yet. */
export function fieldTileRefetchInterval(
  field: { guid?: string; tiles?: string[] } | undefined
): number | false {
  if (!onlineManager.isOnline()) {
    return false;
  }
  if (field && (!field.tiles || field.tiles.length === 0)) {
    return TILE_POLLING_INTERVAL_MS + stableJitterMs(field.guid);
  }
  return false;
}
